// Minimal authenticated fetch to the Felacoo backend for the engine (no Deriv credentials ever reach the browser).
export async function backendGet<T = any>(path: string, params: Record<string, unknown> = {}, timeoutMs = 30000): Promise<T> {
  const base = process.env.REACT_APP_BACKEND_URL;
  const token = localStorage.getItem("felacoo_token");
  const qs = Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== "").map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(String(v))}`).join("&");
  const ctrl = new AbortController();
  const timer = setTimeout(() => ctrl.abort(), timeoutMs);
  try {
    const res = await fetch(`${base}/api${path}${qs ? `?${qs}` : ""}`, { headers: token ? { Authorization: `Bearer ${token}` } : {}, signal: ctrl.signal, credentials: "include" });
    if (!res.ok) {
      let detail: any = null;
      try { detail = (await res.json()).detail; } catch { /* ignore */ }
      throw new Error(detail?.message || `${res.status} ${path}`);
    }
    return (await res.json()) as T;
  } finally {
    clearTimeout(timer);
  }
}
